export default "__VITE_ASSET__B95qr_FX__"